module.exports = __webpack_public_path__ + "static/img/07-人大附中亦庄新城学校1.1e66bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/07-人大附中亦庄新城学校1.png
// module id = lc3/
// module chunks = 0